import { useEffect, useRef } from 'react';

export const useOTP = (
    callback: (OTPValue: string | null) => void,
    credentialsRequestId: number,
    onCredetialsRequestFail?: (error: Error) => void
): void => {
    const callbackRef = useRef(callback);
    const onFailCallbackRef = useRef(onCredetialsRequestFail);
    callbackRef.current = callback;
    onFailCallbackRef.current = onCredetialsRequestFail;

    useEffect(() => {
        if (!('OTPCredential' in window)) {
            return undefined;
        }

        const ac = new AbortController();

        navigator.credentials
            .get({
                otp: { transport: ['sms'] },
                signal: ac.signal,
            } as CredentialRequestOptions)
            // ts не знает о типе OTPCredentials
            .then((otp) => callbackRef.current((otp as unknown as { code: string })?.code))
            .catch((error) => {
                onFailCallbackRef.current?.(error as Error);
            });

        return () => {
            ac.abort();
        };
    }, [credentialsRequestId]);
};
